<template>
    <transition 
        enter-from-class="opacity-0"
        enter-active-class="ease-out duration-300"
        enter-to-class="opacity-100"
        leave-from-class="opacity-100"
        leave-active-class="ease-in duration-200"
        leave-to-class="opacity-0">
        <slot></slot>
    </transition>
</template>

<script setup lang="ts">
</script>